<template>
    <div class="main-cn">
        <div class="main-bd mg20">
            <el-row class="searchSection" >
                <SearchForm 
                :params="searcheModel" 
                :fields="fields" 
                :cache_field="'search_config_' + active_name + '_' + this.$route.path" 
                @search="submitSearch" 
                @reset="resetForm" 
                :key="search_form_key"> 
                </SearchForm>
            </el-row>
            <el-row :gutter="10" class="searchSection">
                <el-col :span="4">
                    <el-card>
                        <el-row class="searchSection">
                            <el-col :span="5">
                                <label class="item-title">集团</label>
                            </el-col>
                            <el-col :span="17" :offset="2">
                                <el-input
                                    size="mini"
                                    placeholder="搜索集团"
                                    prefix-icon="el-icon-search"
                                    v-model="searcheModel.corp_name"
                                    @change="getTree"
                                    clearable>
                                </el-input>
                            </el-col>
                        </el-row>
                        <el-divider class="customr-divider"></el-divider>
                        <el-row class="addBtn">
                            <el-button type="primary" size="small" @click="showCorpDialog(null, false)">新增集团</el-button>
                        </el-row>
                        <el-table
                            :data="tree" 
                            ref="singleTable" 
                            height="752" 
                            highlight-current-row
                            @row-click="setCurrent"
                            :show-header="false"
                            v-loading="tree_loading">
                            <el-table-column>
                                <template slot-scope="scope">
                                    {{scope.row.name}}({{scope.row.customer_num}})
                                    <el-button type="text" class="el-icon-edit" @click="showCorpDialog(scope.row, true)"></el-button>
                                </template>
                            </el-table-column>
                            <el-table-column width="40">
                                <template slot-scope="scope">
                                    <el-button type="text" class="el-icon-delete" @click="deleteCorp([scope.row.id])"></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </el-col>
                <el-col :span="20">
                    <el-card>
                        <label class="item-title">客户列表</label>
                        <el-divider class="customr-divider"></el-divider>
                        <el-row class="addBtn">
                            <el-button type="primary" size="small" @click="showBindDialog">绑定客户</el-button>
                            <el-button type="danger" size="small" @click="showUnbindDialog()" :disabled="multipleSelection.length == 0">批量解绑</el-button>
                        </el-row>
                        <el-table
                        :data="list" 
                        border 
                        height="660"
                        @selection-change="handleSelectionChange"
                        v-loading="loading">
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column prop="id" label="客户ID"></el-table-column>
                            <el-table-column prop="name" label="客户名称"></el-table-column>
                            <el-table-column prop="short_name" label="客户简称"></el-table-column>
                            <!-- <el-table-column prop="corp_name" label="归属集团">
                                <template slot-scope="scope">
                                    <div v-for="(corp, index) in scope.row.corp" :key="index">
                                        {{corp.corp_name}}
                                    </div>
                                </template>
                            </el-table-column> -->
                            <el-table-column prop="district_names" label="所在地区"></el-table-column>
                            <el-table-column prop="customer_trace_num" label="开通产品" width="250">
                                <template slot-scope="scope">
                                    <el-dropdown v-if="scope.row.products.length > 0">
                                        <div class="el-dropdown-link product-buyed" >
                                            <div v-for="(product, index) in _.orderBy(scope.row.products,['end_at','open_state'], ['desc', 'desc']).slice(0, 2)" :key="index">
                                                【{{product.state}}】{{product.product_name}}
                                                <span v-if="product.is_expire == '已到期'" style="color:red;">{{product.is_expire}}</span>
                                                <span v-else-if="product.is_expire != ''" style="color:green;">{{product.is_expire}}</span>
                                                <br>{{product.start_at_memo}}~{{product.end_at_memo}}
                                            </div>
                                        </div>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item v-for="(product, index) in _.orderBy(scope.row.products,['end_at','open_state'], ['desc', 'desc'])" :key="index" >
                                                <p>【{{product.state}}】{{product.product_name}}
                                                    <span style="color:red;" v-if="product.is_expire.indexOf('已到期')==0">{{product.is_expire}}</span>
                                                    <span style="color:green;" v-else>{{product.is_expire}}</span>
                                                </p>
                                                <p>{{product.start_at_memo}}~{{product.end_at_memo}}</p>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                            <el-table-column prop="item_num" label="绑定资源数"></el-table-column>
                            <el-table-column prop="xueduan_str" label="开设学段"></el-table-column>
                            <el-table-column prop="type_name" label="客户类型">
                                <template slot-scope="scope">
                                    {{scope.row.type_name}}
                                    <span v-for="(tag, index) in scope.row.tag" :key="index">
                                        /{{tag.tag_name}}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="username" label="业务员/协作人">
                                <template slot-scope="scope">
                                    {{scope.row.user ? scope.row.user.name : ''}}
                                    <div v-for="(cooperator, index) in scope.row.cooperator" :key="index">
                                        {{cooperator.user_name}}（协作）
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="showUnbindDialog(scope.row)">解除绑定</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <el-dialog :title="is_edit ? '编辑集团' : '新增集团'" :visible.sync="dialogCorp" width="40%">
            <el-form ref="corp_form" :model="corp_form" :rules="corp_rules">
                <el-form-item label="集团名称" prop="name">
                    <el-input v-model="corp_form.name" placeholder="请输入集团名称"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="memo">
                    <el-input v-model="corp_form.memo" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item label="创建人" v-if="is_edit">
                    {{corp_form.operator_name}}
                </el-form-item>
                <el-form-item label="创建时间" v-if="is_edit">
                    {{corp_form.created_at}}
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogCorp = false">取 消</el-button>
                <el-button type="primary" @click="createCorp()" :loading="form_loading">确 定</el-button>
            </div>
        </el-dialog>
        <CustomerList v-if="dialogBind" :params="corp" @change="getTree" :key="bind_dialog_key"></CustomerList>
    </div>
        
</template>
<style scoped>
.customr-divider {
    margin: 10px 0; /* 上边距10px，下边距10px */
}

</style>
<script>
import CustomerStdService from "~/services/CustomerStd";
import SearchForm from "~/widgets/SearchForm.vue";
import MyPagination from "~/widgets/MyPagination.vue";
import CustomerList from "~/views/customer-std/dialog/CustomerList.vue";
export default {
    name: "std-list",

    components: {
        SearchForm,
        MyPagination,
        CustomerList
    },

    data() {
        return {
            tree: [],
            list: [],
            tree_loading: false,
            loading: false,
            searcheModel: {},
            fields: [],
            search_form_key: 0,
            dialogBind: false,
            form_loading: false,
            multipleSelection: [],
            form: {
                customer_ids: [],
                memo: ''  
            },
            is_edit: false,
            dialogCorp: false,
            corp_form: {
                name: '',
                memo: '',
            },
            linkPage: null,
            rules: {
                memo: [{required: true, message: "请输入备注信息", trigger: "blur"}],
            },
            corp_rules: {
                name: [{required: true, message: "请输入集团名称", trigger: "blur"}],
            },
            active_name: 'corp-list',
            corp: {
                id: '',
            },
            bind_dialog_key: 0,
        }
    },

    created: function () {
        //请求侧边栏地区树
        this.getTree();
        this.resetForm(false);
    },
    
    methods: {
        //重置按钮
        resetForm(is_search = true) {
            this.fields = CustomerStdService.getFields(this.$route.path, );
            this.searcheModel = {};
            this.list = [];
            this.search_form_key ++;
            if(is_search){
                this.submitSearch();
            }
        },

        // 筛选查询
        submitSearch(params = null) {
            if(params){
                this.searcheModel = params;
            }
            params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
        },

        //获取列表
        getTree() {
            if (!this.active_name || this.active_name < 1) {
                this.$message({
                    message: '无相关列表权限，请先授权！',
                    type: 'error'
                });
                return;
            }
            // loading 动画
            this.tree_loading = true;
            const params = {
                expand: 'customer_num',
                corp_name: this.searcheModel.corp_name,
                perPage: 100,
            };
            CustomerStdService.getList(params, this.active_name)
            .then((res) => {
                if (res.code == 0) {
                    this.tree = res.data;
                    if (this.tree.length > 0){
                        const node = this.corp.id ? this.tree.find(treeItem => treeItem.id == this.corp.id) : this.tree[0];
                        this.setCurrent(node);
                    }
                }
                this.tree_loading = false;
                
            })
            .catch((err) => {
                console.error(err);
                this.tree_loading = false;
            });
        },

        //获取列表
        getList(params) {
            if (!this.corp.id){
                this.$message({
                    message: '请先选择集团',
                    type: 'error'
                });
                return;
            }
            if(this.tree.length > 0){
                // loading 动画
                this.loading = true;
                params['corp_ids'] = [this.corp['id']];
                CustomerStdService.getList(params, 'index')
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                    }
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
            }
        },



        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        //展示批量删除客户对话框
        showCorpDialog(row = null, is_edit = false) {
            if(row) {
                this.corp_form = row;
            }else{
                this.corp_form = {
                    name: '',
                    memo: '',
                };
            }
            this.is_edit = is_edit;
            this.dialogCorp = true;
        },

        //展示批量删除客户对话框
        showBindDialog() {
            this.bind_dialog_key ++;
            this.dialogBind = true;
        },

        //添加集团
        createCorp() {
            this.$refs["corp_form"].validate(valid => {
                this.form_loading = false;
                if (valid) {
                    let corp_service = null;
                    if(this.is_edit){
                        corp_service = CustomerStdService.updateCorp(this.corp_form)
                    }else{
                        corp_service = CustomerStdService.createCorp(this.corp_form)
                    }
                    corp_service.then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message: (this.is_edit ? '编辑' : '创建') + '成功',
                                type: 'success'
                            });
                            this.getTree();
                        }
                        this.dialogCorp = false;
                    })
                } else {
                    this.form_loading = false;
                    return false;
                }
            });
        },

        deleteCorp(ids) {
            this.$confirm("确认删除企业吗？", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            }).then(() => {
                CustomerStdService.deleteCorp({ids: ids})
                .then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getTree();
                    }
                })
            }).catch((err) => {
                console.error(err);
            });
            
        },

        //解绑客户
        showUnbindDialog(customer = null) {
            let ids = [];
            if(!customer){
                ids = this.multipleSelection.map(item => item.id);
            }else{
                ids = [customer.id];
            }
            if (ids.length == 0){
                this.$message({
                    message: '请先选择解绑客户',
                    type: 'error'
                });
                return;
            }
            this.$confirm("确认将客户从企业解绑？", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            }).then(() => {
                this.unbindCorp(ids);
            }).catch((err) => {
                console.error(err);
            });
        },

        //解绑客户
        unbindCorp(customer_ids) {
            CustomerStdService.unbindCorp({corp_id: this.corp.id, customer_ids: customer_ids}).then(res => {
                if(res.code == 0){
                    this.$message({
                        message: '解绑成功',
                        type: 'success'
                    });
                    this.getTree();
                }else{
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            }).catch((err) => {
                console.error(err);
            });
        },

        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            this.searcheModel['perPage'] = newSize;
            this.submitSearch();
        },

        handleCurrentChange(newPage) {
            // 处理当前页码变化事件
            this.searcheModel['page'] = newPage;
            this.submitSearch();
        },

        //选中行
        setCurrent(row) {
            this.corp = row;
            this.$refs.singleTable.setCurrentRow(row);
            this.submitSearch();
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/customer-std/corp-list.vue